import { createMiddleware } from '@shared/redux';
import { showErrorToast } from '@shared/toasts';
import { changePaymentMethodModalStep } from '@domain/billing/interface/interface.state';
import { PAYMENT_METHOD_ERRORS } from '@domain/billing/payment-method/payment-method.constants';
import { handleSubmitStripeCustomer } from '@domain/billing/stripe/stripe-customer';
import { getSubmitChangePaymentMethodFlags, SUBMIT_CHANGE_PAYMENT_METHOD } from './payment-method.state';

export const paymentMethodMiddlewares = createMiddleware({
    [SUBMIT_CHANGE_PAYMENT_METHOD]: (state, action) => {
        const { hasBillingDetails } = getSubmitChangePaymentMethodFlags(state);
        if (!hasBillingDetails) {
            return [
                showErrorToast({ message: PAYMENT_METHOD_ERRORS.BILLING_DETAILS_NEEDED }),
                changePaymentMethodModalStep({ billingDetails: true }),
            ];
        }

        const { paymentMethodId } = action.payload;
        return handleSubmitStripeCustomer(paymentMethodId);
    },
});
